module.exports = __webpack_public_path__ + "static/assets/0f52aaddde48ca7dfd58708fd379c5a1.png";